import { useIsVisible } from '@folklore/hooks';
import { useTracking } from '@folklore/tracking';
import classNames from 'classnames';
import { useEffect } from 'react';

import { useSubscribed } from '../../hooks/useSubscription';

import { useMatchedPromotions } from '../../contexts/PromotionsContext';
import PromotionSubscriptionCard from '../cards/PromotionSubscriptionCard';

import styles from '../../styles/blocks/subscription-block.module.css';

interface SubscriptionBlockProps {
    className?: string | null;
    [key: string]: unknown;
}

function SubscriptionBlock({ className = null, ...props }: SubscriptionBlockProps) {
    const matchedPromotions = useMatchedPromotions();
    const [currentPromotion = null] = matchedPromotions.filter(
        ({ type, placement }) => type === 'subscription' && placement === 'block',
    );
    const subscribed = useSubscribed(
        currentPromotion !== null ? currentPromotion.subscription : null,
    );
    const { ref: refVisible, visible } = useIsVisible({
        persist: true,
    });
    const tracking = useTracking();

    useEffect(() => {
        if (visible && currentPromotion !== null) {
            tracking.trackPromotion(currentPromotion, 'impression');
        }
    }, [currentPromotion, visible, tracking]);

    if (subscribed || currentPromotion === null) {
        return null;
    }

    return (
        <div className={classNames([styles.container, className])} ref={refVisible}>
            <PromotionSubscriptionCard
                {...currentPromotion}
                {...props}
                className={styles.card}
                innerClassName={styles.inner}
            />
        </div>
    );
}

export default SubscriptionBlock;
